import React from 'react'
import '../Concierge/concierge.css'
import Constant, { getCurrency } from '../../Constant.js'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'
import '../Concierge/concierge-responsive.css'

/**
 * ChaletAddOns - Dedicated AddOns component for Chalet booking flow
 * Supports: FUN (Diwaniya), FOOD (Waves Market), STORE, CATERING
 * Uses chalet-specific APIs based on doc.md specifications
 */
class ChaletAddOns extends React.Component {
    state = {
        activeTab: this.props.data.tab[0].id,
        activeAddOnTab: {},
        activeAddOnSubTab: 0,
        isLoading: false,
        initialLoading: false,
        tabList: this.props.data.tab,
        bookingId: this.props.data.id,
        title: this.props.data?.chalet_name || this.props.data?.chalet_data?.name_en || '',
        circleTab: [],
        foodOrStoreSelectOnceData: {},
        cartList: [],
        cartItemList: {},
        showCart: false,
        descriptionExpand: 1,
        totalAmt: 0,
        bookingData: {},
        showCheckout: false,
        storeMinAmtOrder: {},
        detailsOfitem: null,
        enable_b2b_prices: this.props.data.enable_b2b_prices,
        chalet_id: this.props.data.chalet_id || '',
        bookingPayload: this.props.data.bookingPayload || {},
        // Catering specific state
        showItemDetail: false,
        selectedItem: null,
        personCount: 0,
        selectedCateringOptions: {},
        specialRequest: '',
        // Loading states
        isLoadingStores: false,
        isLoadingItems: false,
        isProcessingCheckout: false,
        isProcessingPayment: false,
        // Delivery date/time state
        showDeliveryModal: false,
        deliverySlots: [],
        isLoadingDeliverySlots: false,
        selectedDeliveryDate: null,
        selectedDeliveryTime: null,
        deliveryCalendarMonth: moment(),
    }

    componentDidMount() {
        this.imageManger = this.imageManger.bind(this)
        this.storeMinOrderAmtAlert = this.storeMinOrderAmtAlert.bind(this)
        this.tabHandler()
    }

    renderInlineLoader = (height = 100) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: height, width: '100%' }}>
            <div style={{ width: 30, height: 30, border: '3px solid #f3f3f3', borderTop: '3px solid #00547e', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        </div>
    )

    setActiveTab = (tabDetail) => {
        this.setState({
            activeTab: tabDetail,
            activeAddOnSubTab: 0,
            circleTab: [],
            activeAddOnTab: {},
            foodOrStoreSelectOnceData: {}
        }, () => this.tabHandler())
    }

    setActiveAddOnTab = (subTabName) => {
        this.setState({ activeAddOnTab: subTabName, activeAddOnSubTab: 0, foodOrStoreSelectOnceData: {} }, () => {
            if (this.state.activeTab !== 'FUN') {
                this.getChaletStoreItems()
            }
        })
    }

    setActiveAddOnSubTab = (subChildTabName) => {
        this.setState({ activeAddOnSubTab: subChildTabName })
    }

    tabHandler = () => {
        if (this.state.activeTab === 'FUN') {
            this.getChaletDiwaniyaList()
        } else {
            this.getChaletStoreList()
        }
    }

    // API for FUN tab - Diwaniya items
    getChaletDiwaniyaList = () => {
        this.setState({ isLoadingStores: true })
        const apiUrl = `${Constant.getAPI()}/diwaniya/chalet-diwaniya/${this.state.chalet_id}?booking_id=${this.state.bookingId}`

        axios.get(apiUrl, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
        })
            .then((res) => {
                if (res.data.success) {
                    this.setState({ circleTab: res.data.data }, () => {
                        if (res.data.data?.length > 0) this.setActiveAddOnTab(res.data.data[0])
                    })
                }
            })
            .catch((err) => {
                if (err?.response?.status === 401) Constant.getAuthLogout()
                else Swal.fire({ title: err?.response?.data?.message || 'Error loading add-ons', icon: 'error', confirmButtonText: 'Ok' })
            })
            .finally(() => this.setState({ isLoadingStores: false }))
    }

    // API for FOOD, STORE, CATERING tabs - Store list
    getChaletStoreList = () => {
        this.setState({ isLoadingStores: true })
        const apiUrl = `${Constant.getAPI()}/chalet/chalet-store-list/${this.state.activeTab}?booking_id=${this.state.bookingId}`

        axios.get(apiUrl, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
        })
            .then((res) => {
                if (res.data.success) {
                    this.setState({ circleTab: res.data.data }, () => {
                        if (res.data.data?.length > 0) this.setActiveAddOnTab(res.data.data[0])
                    })
                }
            })
            .catch((err) => {
                if (err?.response?.status === 401) Constant.getAuthLogout()
                else Swal.fire({ title: err?.response?.data?.message || 'Error loading stores', icon: 'error', confirmButtonText: 'Ok' })
            })
            .finally(() => this.setState({ isLoadingStores: false }))
    }

    // API for store items
    getChaletStoreItems = () => {
        if (!this.state.activeAddOnTab?.id) return
        this.setState({ isLoadingItems: true, foodOrStoreSelectOnceData: {} })
        const apiUrl = `${Constant.getAPI()}/chalet/chalet-store-items-list/${this.state.activeAddOnTab.id}`

        axios.get(apiUrl, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
        })
            .then((res) => {
                if (res.data.success) this.setState({ foodOrStoreSelectOnceData: res.data.data })
            })
            .catch((err) => {
                if (err?.response?.status === 401) Constant.getAuthLogout()
                else Swal.fire({ title: err?.response?.data?.message || 'Error loading items', icon: 'error', confirmButtonText: 'Ok' })
            })
            .finally(() => this.setState({ isLoadingItems: false }))
    }

    imageManger = (value) => {
        const imgUrl = value ? Constant.getImage() + value : './assets/images/waves-logo.svg'
        return <img alt="" src={imgUrl} onError={({ currentTarget }) => { currentTarget.src = './assets/images/waves-logo.svg' }} />
    }

    addOrRemoveFromCart = async (data, value) => {
        let obj = { ...data }
        let total = 0
        let StoreObj = { ...this.state.storeMinAmtOrder }
        if (this.state.itemaddingRemove) return
        let id = obj.id
        let price = obj.price
        let list = this.state.cartItemList

        if (!value) {
            // Removing from cart
            if (!(list['id' + id] && list['id' + id].id)) return
            list['id' + id].qty = list['id' + id].qty - 1
            if (list['id' + id].qty === 0) delete list['id' + id]
            if (obj.storeId) {
                let totalAmtOfStoreItem = StoreObj['pId' + obj.storeId]?.amt || 0
                StoreObj['pId' + obj.storeId] = { amt: totalAmtOfStoreItem - price, orderAmt: data.orderAmt, name: data.storeName }
            }
            total = this.state.totalAmt - price
        } else {
            // Adding to cart
            let qtyIs = list['id' + id]?.qty || 0

            // Validation: Check stock limit
            if (obj.stock_limit && obj.stock_limit <= qtyIs) {
                Swal.fire('Item out of Stock', '', 'warning')
                return
            }

            // Validation: Items with options should use detail popup
            if (obj.store_item_options && obj.store_item_options.length > 0 && !obj.store_item_option_id) {
                this.setState({ detailsOfitem: obj })
                return
            }

            if (!(list['id' + id] && list['id' + id].id)) {
                list['id' + id] = {
                    ...obj,
                    qty: 1,
                    id: obj.id,
                    img: obj.img,
                    title: obj.title,
                    price: obj.price,
                    notes: obj.notes,
                    store_item_option_id: obj.store_item_option_id,
                    store_id: obj.storeId || obj.store_id,
                }
            } else {
                // Diwaniya items can only have 1 qty
                if (obj?.diwaniya) {
                    Swal.fire('You can select max 1 qty per item', '', 'warning')
                    return
                }
                if (list['id' + id].qty > 0) {
                    list['id' + id].qty = list['id' + id].qty + 1
                }
            }
            if (obj.storeId) {
                let totalAmtOfStoreItem = StoreObj['pId' + obj.storeId]?.amt || 0
                StoreObj['pId' + obj.storeId] = { amt: totalAmtOfStoreItem + price, orderAmt: data.orderAmt, name: data.storeName }
            }
            total = this.state.totalAmt + price
        }
        this.setState({ cartItemList: { ...list }, totalAmt: total, storeMinAmtOrder: { ...StoreObj } })
    }

    Checkout = () => {
        let arr = Object.values(this.state.cartItemList)
        let additional_items_list = []
        let diwaniya_items_list = []
        let a = Object.values(this.state.storeMinAmtOrder).find((value) => value.amt < value.orderAmt && value.amt !== 0)
        if (a) { Swal.fire(`${a.name} is ${a.orderAmt} ${getCurrency(localStorage.getItem('countryShortName'))} minimum`, '', 'warning'); return }

        for (let item of arr) {
            let totalItemQty = item.qty || 1

            // Diwaniya items
            if (item.diwaniya) {
                diwaniya_items_list.push({
                    add_item_id: item.id,
                    amount: item.price,
                    chalet_id: this.state.chalet_id,
                    item_qty: item.qty,
                    notes: item?.notes || '',
                    store_item_option_id: item?.store_item_option_id || '',
                })
            }
            // Catering items
            else if (item.isCateringItem && item.cateringCategories && item.selectedCateringOptions) {
                const cateringItems = []
                let totalCateringQty = 0

                item.cateringCategories.forEach((category) => {
                    const categoryOptions = item.selectedCateringOptions[category.id] || {}
                    category.items.forEach((catItem) => {
                        const qty = categoryOptions[catItem.id] || 0
                        if (qty > 0) {
                            totalCateringQty += qty
                            cateringItems.push({
                                amount: catItem.price || 0,
                                category_id: category.id,
                                is_addon: category.is_addon || false,
                                item_id: catItem.id,
                                item_qty: qty,
                            })
                        }
                    })
                })

                totalItemQty = item.personCount || totalCateringQty || 1
                additional_items_list.push({
                    add_item_id: item.id,
                    amount: String(item.price),
                    store_id: item.storeId || item.store_id,
                    item_qty: String(totalItemQty),
                    notes: item?.notes || '',
                    store_item_option_id: item?.store_item_option_id || '',
                    chalet_id: this.state.chalet_id,
                    catering_items: cateringItems,
                })
            }
            // Regular store items
            else {
                additional_items_list.push({
                    add_item_id: item.id,
                    amount: String(item.price),
                    store_id: item.storeId || item.store_id,
                    item_qty: String(totalItemQty),
                    notes: item?.notes || '',
                    store_item_option_id: item?.store_item_option_id || '',
                    chalet_id: this.state.chalet_id,
                })
            }
        }

        // Format delivery date and time for API
        const deliveryDate = this.state.selectedDeliveryDate
            ? moment(this.state.selectedDeliveryDate).format('MM/DD/YYYY')
            : ''
        const [deliveryStartTime, deliveryEndTime] = this.state.selectedDeliveryTime
            ? this.state.selectedDeliveryTime.split('-')
            : ['', '']

        const data = {
            diwaniya_items_list,
            additional_items_list,
            booking_id: this.state.bookingId,
            is_b2b: this.state.enable_b2b_prices,
            delivery_date: deliveryDate,
            delivery_start_time: deliveryStartTime,
            delivery_end_time: deliveryEndTime,
        }
        this.onCheckout(data)
    }

    productCard = (img, title, price, data, checkQty = 0) => {
        let obj = data
        obj['qty'] = this.state.cartItemList['id' + data.id]?.qty || 0
        obj['store_item_option_id'] = this.state.cartItemList['id' + data.id]?.store_item_option_id || ''
        obj['notes'] = this.state.cartItemList['id' + data.id]?.notes || ''
        obj['img'] = img
        obj['title'] = title
        obj['price'] = price

        if (checkQty && !obj.qty) return
        return (
            <div className="add-box-data">
                <div onClick={() => this.setState({ detailsOfitem: data })}>{this.imageManger(img)}</div>
                <div className="box-under-data">
                    <p>{title}</p>
                    <div className="under-data-price">
                        <p>{this.state.cartItemList['id' + data.id]?.price || price} {getCurrency(localStorage.getItem('countryShortName'))}</p>
                        {data.store_item_options?.length ? (
                            <div className="showwAll" onClick={() => this.setState({ detailsOfitem: obj })}>Show All</div>
                        ) : (
                            <div className="count-data">
                                <span className="box" onClick={() => this.addOrRemoveFromCart(data, 0)}>-</span>
                                <div>{obj.qty}</div>
                                <span className="box" onClick={() => this.addOrRemoveFromCart(data, 1)}>+</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    handleCart = () => {
        this.setState({ showCart: this.state.showCheckout ? 1 : 0, showCheckout: 0 })
    }

    onCheckout = async (data) => {
        this.setState({ isData: true, isProcessingCheckout: true, bookingData: {} })
        const { bookingId } = this.state

        // Add delivery date/time to each item in additional_items_list
        const additionalItemsWithDelivery = (data.additional_items_list || []).map(item => ({
            ...item,
            delivery_date: data.delivery_date || '',
            delivery_time: data.delivery_start_time || '',
        }))

        // Add delivery date/time to each item in diwaniya_items_list
        const diwaniyaItemsWithDelivery = (data.diwaniya_items_list || []).map(item => ({
            ...item,
            delivery_date: data.delivery_date || '',
            delivery_time: data.delivery_start_time || '',
        }))

        const payload = {
            booking_id: bookingId,
            additional_items_list: additionalItemsWithDelivery,
            diwaniya_items_list: diwaniyaItemsWithDelivery,
        }

        await axios.post(`${Constant.getAPI()}/chalet/admin-chalet-checkout`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
        })
            .then((res) => {
                if (res.data.success) {
                    this.setState({
                        bookingData: res.data.data,
                        showCheckout: true,
                        // Store delivery info for payment
                        checkoutDeliveryDate: data.delivery_date,
                        checkoutDeliveryTime: data.delivery_start_time || '',
                    })
                }
            })
            .catch((err) => {
                if (err?.response?.status === 401) Constant.getAuthLogout()
                else Swal.fire({ title: err?.response?.data?.message || 'Checkout failed', icon: 'error', confirmButtonText: 'Ok' })
            })
            .finally(() => this.setState({ isData: false, isProcessingCheckout: false }))
    }

    buildAdditionalItemsList = () => {
        const arr = Object.values(this.state.cartItemList)
        const additional_items_list = []

        for (const item of arr) {
            // Skip diwaniya items - they go in separate list
            if (item.diwaniya) continue

            let totalItemQty = item.qty || 1

            if (item.isCateringItem && item.cateringCategories && item.selectedCateringOptions) {
                const cateringItems = []
                let totalCateringQty = 0

                item.cateringCategories.forEach((category) => {
                    const categoryOptions = item.selectedCateringOptions[category.id] || {}
                    category.items.forEach((catItem) => {
                        const qty = categoryOptions[catItem.id] || 0
                        if (qty > 0) {
                            totalCateringQty += qty
                            cateringItems.push({
                                amount: catItem.price || 0,
                                category_id: category.id,
                                is_addon: category.is_addon || false,
                                item_id: catItem.id,
                                item_qty: qty,
                            })
                        }
                    })
                })

                totalItemQty = item.personCount || totalCateringQty || 1
                additional_items_list.push({
                    add_item_id: item.id,
                    item_qty: totalItemQty,
                    store_item_option_id: item?.store_item_option_id || '',
                    notes: item?.notes || '',
                    catering_items: cateringItems,
                })
            } else {
                additional_items_list.push({
                    add_item_id: item.id,
                    item_qty: totalItemQty,
                    store_item_option_id: item?.store_item_option_id || '',
                    notes: item?.notes || '',
                })
            }
        }

        return additional_items_list
    }

    processPayment = async () => {
        this.setState({ isProcessingPayment: true })
        const { bookingData, checkoutDeliveryDate, checkoutDeliveryTime } = this.state

        // Build items lists with delivery info
        const arr = Object.values(this.state.cartItemList)
        const additional_items_list = []
        const diwaniya_items_list = []

        for (const item of arr) {
            const baseItem = {
                add_item_id: item.id,
                item_qty: item.qty || 1,
                store_item_option_id: item?.store_item_option_id || '',
                notes: item?.notes || '',
                delivery_date: checkoutDeliveryDate || '',
                delivery_time: checkoutDeliveryTime || '',
            }

            if (item.diwaniya) {
                diwaniya_items_list.push(baseItem)
            } else if (item.isCateringItem && item.cateringCategories && item.selectedCateringOptions) {
                const cateringItems = []
                item.cateringCategories.forEach((category) => {
                    const categoryOptions = item.selectedCateringOptions[category.id] || {}
                    category.items.forEach((catItem) => {
                        const qty = categoryOptions[catItem.id] || 0
                        if (qty > 0) {
                            cateringItems.push({
                                category_id: category.id,
                                item_id: catItem.id,
                                item_qty: qty,
                                amount: catItem.price || 0,
                                is_addon: category.is_addon || false,
                            })
                        }
                    })
                })
                additional_items_list.push({
                    ...baseItem,
                    item_qty: item.personCount || item.qty || 1,
                    catering_items: cateringItems,
                })
            } else {
                additional_items_list.push(baseItem)
            }
        }

        const body = {
            booking_id: bookingData?.id,
            additional_items_list,
            diwaniya_items_list,
            DisplayCurrencyIso: bookingData?.currency,
        }

        await axios.post(`${Constant.getAPI()}/chalet/process-chalet-payment`, body, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
        })
            .then((res) => {
                if (res?.data?.success) {
                    Swal.fire({ title: 'Payment Link Sent', icon: 'success', text: 'Payment link has been sent to customer via WhatsApp and Email', confirmButtonText: 'Booking Details' }).then(() => {
                        window.location.href = `#/chalet-booking-details/${bookingData?.id}`
                    })
                    this.props.clearData()
                }
            })
            .catch((err) => {
                if (err?.response?.status === 401) Constant.getAuthLogout()
                else Swal.fire({ title: err?.response?.data?.message || 'Payment failed', icon: 'error', confirmButtonText: 'Ok' })
            })
            .finally(() => this.setState({ isProcessingPayment: false }))
    }

    bottmBtn = () => {
        if (this.state.showCart) {
            // Validate delivery date/time is selected
            if (Object.keys(this.state.cartItemList).length > 0 && (!this.state.selectedDeliveryDate || !this.state.selectedDeliveryTime)) {
                Swal.fire('Please select delivery date and time', '', 'warning')
                this.openDeliveryModal()
                return
            }
            this.Checkout()
        } else {
            let a = Object.values(this.state.storeMinAmtOrder).find((value) => value.amt < value.orderAmt && value.amt !== 0)
            if (a) { Swal.fire(`${a.name} is ${a.orderAmt} ${getCurrency(localStorage.getItem('countryShortName'))} minimum`, '', 'warning'); return }
            let tabList = [...this.state.tabList]
            let indexOfCurrentTab = this.state.tabList.findIndex((ele) => ele.id === this.state.activeTab) + 1
            if (indexOfCurrentTab === tabList.length) {
                this.setState({ showCart: 1 })
            } else {
                this.setActiveTab(tabList[indexOfCurrentTab].id)
            }
        }
    }

    storeMinOrderAmtAlert = () => {
        let store = this.state.storeMinAmtOrder['pId' + this.state.foodOrStoreSelectOnceData.id]
        if (store && store.amt < store.orderAmt && store.amt !== 0 && !this.state.showCart && !this.state.showCheckout) {
            return <div style={{ background: 'aqua', fontSize: '13px', textAlign: 'center' }}>Minimum Order limit of {store.name} is {store.orderAmt} {getCurrency(localStorage.getItem('countryShortName'))}</div>
        }
        return ''
    }

    // Fetch delivery slots when cart is shown
    fetchDeliverySlots = async () => {
        this.setState({ isLoadingDeliverySlots: true })
        try {
            const response = await axios.post(
                `${Constant.getAPI()}/chalet/chalet-store-delivery-slots`,
                { booking_id: this.state.bookingId },
                { headers: { Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}` } }
            )
            if (response.data.success) {
                const slots = response.data.data || []
                // Set calendar month to first available delivery date's month
                let calendarMonth = moment()
                if (slots.length > 0) {
                    const firstAvailableDate = moment(slots[0].date, 'MM/DD/YYYY')
                    calendarMonth = firstAvailableDate.clone().startOf('month')
                }
                this.setState({
                    deliverySlots: slots,
                    deliveryCalendarMonth: calendarMonth
                })
            }
        } catch (error) {
            console.error('Error fetching delivery slots:', error)
        } finally {
            this.setState({ isLoadingDeliverySlots: false })
        }
    }

    // Open delivery modal
    openDeliveryModal = () => {
        if (this.state.deliverySlots.length === 0) {
            this.fetchDeliverySlots()
        }
        this.setState({ showDeliveryModal: true })
    }

    // Close delivery modal
    closeDeliveryModal = () => {
        this.setState({ showDeliveryModal: false })
    }

    // Select delivery date
    selectDeliveryDate = (date) => {
        this.setState({ selectedDeliveryDate: date, selectedDeliveryTime: null })
    }

    // Select delivery time
    selectDeliveryTime = (time) => {
        this.setState({ selectedDeliveryTime: time })
    }

    // Confirm delivery selection
    confirmDeliverySelection = () => {
        if (this.state.selectedDeliveryDate && this.state.selectedDeliveryTime) {
            this.setState({ showDeliveryModal: false })
        } else {
            Swal.fire('Please select date and time', '', 'warning')
        }
    }

    // Format time for display (24h to 12h)
    formatTimeSlot = (startTime, endTime) => {
        const formatTime = (time) => {
            const [hours, minutes] = time.split(':')
            const hour = parseInt(hours)
            const ampm = hour >= 12 ? 'PM' : 'AM'
            const hour12 = hour % 12 || 12
            return `${hour12}:${minutes} ${ampm}`
        }
        return `${formatTime(startTime)} - ${formatTime(endTime)}`
    }

    // Get available dates from delivery slots
    getAvailableDates = () => {
        return this.state.deliverySlots.map(slot => moment(slot.date, 'MM/DD/YYYY').format('YYYY-MM-DD'))
    }

    // Get time slots for selected date
    getTimeSlotsForDate = (date) => {
        const slot = this.state.deliverySlots.find(s => moment(s.date, 'MM/DD/YYYY').format('YYYY-MM-DD') === date)
        return slot ? slot.delivery_time : []
    }

    // Render delivery date/time modal
    renderDeliveryModal = () => {
        if (!this.state.showDeliveryModal) return null

        const { selectedDeliveryDate, selectedDeliveryTime, deliveryCalendarMonth, isLoadingDeliverySlots } = this.state
        const availableDates = this.getAvailableDates()
        const timeSlots = selectedDeliveryDate ? this.getTimeSlotsForDate(selectedDeliveryDate) : []
        const chaletData = this.props.data?.chalet_data || {}

        // Calendar navigation
        const canGoBack = deliveryCalendarMonth.isAfter(moment().startOf('month'), 'month')

        return (
            <div className="App">
                <div className="popup-backdrop" onClick={this.closeDeliveryModal}>
                    <div
                        className="popup-content"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            width: '90%',
                            maxWidth: '420px',
                            padding: '20px',
                            borderRadius: '16px',
                            maxHeight: '90vh',
                            overflow: 'auto'
                        }}
                    >
                        {/* Header */}
                        <h4 style={{ margin: '0 0 15px 0', fontSize: '18px', fontWeight: '600', color: '#333' }}>
                            {chaletData.name_en || 'Select Delivery'}
                        </h4>

                        {/* Check-in/Check-out Info */}
                        {chaletData.check_in_time && (
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '12px 15px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                marginBottom: '20px'
                            }}>
                                <div>
                                    <div style={{ fontSize: '12px', color: '#00547e', fontWeight: '600' }}>
                                        <span style={{ marginRight: '5px' }}>📍</span>Check-In
                                    </div>
                                    <div style={{ fontSize: '11px', color: '#666' }}>
                                        Begins at {chaletData.check_in_time}
                                    </div>
                                </div>
                                <div style={{ textAlign: 'right' }}>
                                    <div style={{ fontSize: '12px', color: '#00547e', fontWeight: '600' }}>
                                        <span style={{ marginRight: '5px' }}>📍</span>Check-Out
                                    </div>
                                    <div style={{ fontSize: '11px', color: '#666' }}>
                                        Is by {chaletData.check_out_time}
                                    </div>
                                </div>
                            </div>
                        )}

                        {isLoadingDeliverySlots ? (
                            this.renderInlineLoader(200)
                        ) : (
                            <>
                                {/* Month Navigation */}
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px' }}>
                                    {canGoBack ? (
                                        <div
                                            onClick={() => this.setState({ deliveryCalendarMonth: moment(deliveryCalendarMonth).subtract(1, 'month') })}
                                            style={{ cursor: 'pointer', padding: '5px 15px' }}
                                        >
                                            <span style={{ color: '#00547e', fontSize: '18px', fontWeight: '600' }}>‹</span>
                                        </div>
                                    ) : <div style={{ width: '40px' }}></div>}
                                    <div style={{ color: '#00b4b4', fontSize: '16px', fontWeight: '600', flex: 1, textAlign: 'center' }}>
                                        {deliveryCalendarMonth.format('MMMM, YYYY')}
                                    </div>
                                    <div
                                        onClick={() => this.setState({ deliveryCalendarMonth: moment(deliveryCalendarMonth).add(1, 'month') })}
                                        style={{ cursor: 'pointer', padding: '5px 15px' }}
                                    >
                                        <span style={{ color: '#00547e', fontSize: '18px', fontWeight: '600' }}>›</span>
                                    </div>
                                </div>

                                {/* Day Headers */}
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px', marginBottom: '8px' }}>
                                    {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                                        <div key={day} style={{ textAlign: 'center', fontSize: '12px', color: '#999', fontWeight: '500', padding: '8px 0' }}>
                                            {day}
                                        </div>
                                    ))}
                                </div>

                                {/* Calendar Grid */}
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px', marginBottom: '20px' }}>
                                    {/* Empty cells for days before month starts */}
                                    {Array.from({ length: moment(deliveryCalendarMonth).startOf('month').day() }).map((_, i) => (
                                        <div key={`empty-${i}`} style={{ aspectRatio: '1' }}></div>
                                    ))}

                                    {/* Days of the month */}
                                    {Array.from({ length: deliveryCalendarMonth.daysInMonth() }).map((_, i) => {
                                        const day = i + 1
                                        const dateStr = moment(deliveryCalendarMonth).date(day).format('YYYY-MM-DD')
                                        const isAvailable = availableDates.includes(dateStr)
                                        const isSelected = selectedDeliveryDate === dateStr
                                        const isPast = moment(dateStr).isBefore(moment(), 'day')

                                        return (
                                            <div
                                                key={day}
                                                onClick={() => isAvailable && !isPast && this.selectDeliveryDate(dateStr)}
                                                style={{
                                                    aspectRatio: '1',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '14px',
                                                    fontWeight: isSelected ? '600' : '400',
                                                    color: isPast ? '#ccc' : isAvailable ? (isSelected ? '#fff' : '#333') : '#ccc',
                                                    backgroundColor: isSelected ? '#00b4b4' : 'transparent',
                                                    borderRadius: '50%',
                                                    cursor: isAvailable && !isPast ? 'pointer' : 'default',
                                                }}
                                            >
                                                {day}
                                            </div>
                                        )
                                    })}
                                </div>

                                {/* Time Slots */}
                                {selectedDeliveryDate && timeSlots.length > 0 && (
                                    <div style={{ marginBottom: '20px' }}>
                                        <h5 style={{ margin: '0 0 12px 0', fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                            Select Time
                                        </h5>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                            {timeSlots.map((slot, index) => {
                                                const timeKey = `${slot.start_time}-${slot.end_time}`
                                                const isSelected = selectedDeliveryTime === timeKey
                                                return (
                                                    <div
                                                        key={index}
                                                        onClick={() => this.selectDeliveryTime(timeKey)}
                                                        style={{
                                                            padding: '10px 16px',
                                                            border: `1px solid ${isSelected ? '#00b4b4' : '#ddd'}`,
                                                            borderRadius: '20px',
                                                            fontSize: '12px',
                                                            color: isSelected ? '#00b4b4' : '#666',
                                                            backgroundColor: isSelected ? '#e6f7f7' : '#fff',
                                                            cursor: 'pointer',
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {this.formatTimeSlot(slot.start_time, slot.end_time)}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )}

                                {/* Select Button */}
                                <button
                                    onClick={this.confirmDeliverySelection}
                                    disabled={!selectedDeliveryDate || !selectedDeliveryTime}
                                    style={{
                                        width: '100%',
                                        padding: '14px',
                                        backgroundColor: selectedDeliveryDate && selectedDeliveryTime ? '#1a3a4a' : '#ccc',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        cursor: selectedDeliveryDate && selectedDeliveryTime ? 'pointer' : 'not-allowed',
                                    }}
                                >
                                    Select
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    // Get formatted delivery date/time for display
    getFormattedDeliveryDateTime = () => {
        const { selectedDeliveryDate, selectedDeliveryTime } = this.state
        if (!selectedDeliveryDate || !selectedDeliveryTime) return null

        const [startTime] = selectedDeliveryTime.split('-')
        const formattedTime = this.formatTimeSlot(startTime, startTime).split(' - ')[0]
        const formattedDate = moment(selectedDeliveryDate).format('dddd D MMMM YYYY')

        return `${formattedTime}, ${formattedDate}`
    }

    changeItemDetail = (type, value, other) => {
        let obj = { ...this.state.detailsOfitem }
        if (type === 'QTY') {
            obj.qty = (obj.qty || 0) + (value ? 1 : -1)

            // Validation: Check stock limit
            if (other < obj.qty) {
                Swal.fire('Item out of Stock', '', 'warning')
                return
            }

            // Validation: Diwaniya items can only have 1 qty
            if (obj?.diwaniya && obj.qty > 1) {
                Swal.fire('You can select max 1 qty per item', '', 'warning')
                return
            }

            // Validation: Qty cannot be negative
            if (obj.qty < 0) return

            // Reset notes and option when qty is 0
            if (obj.qty === 0) {
                obj['notes'] = ''
                obj['store_item_option_id'] = ''
            }
        }
        if (type === 'NOT') obj['notes'] = value
        if (type === 'OPT') {
            obj['store_item_option_id'] = value
            let store_item_option = other.find((e) => e.id === value)
            obj['price'] = store_item_option.price
        }
        this.setState({ detailsOfitem: obj })
    }

    setDetailsOfitem = () => {
        let data = this.state.detailsOfitem
        return (
            <div>
                <div className="App">
                    <div className="popup-backdrop" onClick={() => this.setState({ detailsOfitem: '' })}>
                        <div className="popup-content height-width-fix" onClick={(e) => e.stopPropagation()}>
                            <button className="popup-close" onClick={() => this.setState({ detailsOfitem: '' })}>
                                <img src="./assets/icon/concierge/close-black.svg" alt="" />
                            </button>
                            <div className="popupScroll">
                                <div className="popup-data">
                                    <div className="w-50">
                                        <div>
                                            <div className="slider-container img-250">{this.imageManger(data.img)}</div>
                                        </div>
                                    </div>
                                    <div className="w-50">
                                        <div>
                                            <h3 className="m-0">{data.title}</h3>
                                            <div
                                                className="review-location"
                                                style={{ height: '100px', alignItems: 'flex-start', lineHeight: '14px', fontSize: '10px' }}
                                            >
                                                {data.description || data.desc_en}
                                            </div>
                                            <div>
                                                <div className="row">
                                                    <div className="col-8">
                                                        {data.store_item_options && data.store_item_options.length ? (
                                                            <div className="item-dropdown">
                                                                <div className="w-100" style={{ lineHeight: '32px' }}>
                                                                    Chose Your size
                                                                </div>
                                                                <div className="w-100">
                                                                    <select
                                                                        style={{ width: '100%', padding: '0', textAlign: 'center' }}
                                                                        name="country_code"
                                                                        className="form-control border-none"
                                                                        value={data.store_item_option_id}
                                                                        onChange={(event) => {
                                                                            this.changeItemDetail('OPT', event.target.value, data.store_item_options)
                                                                        }}
                                                                    >
                                                                        {data.store_item_options.map((ele) => {
                                                                            return <option key={ele.id} value={ele.id}>{ele.name}</option>
                                                                        })}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        ) : ''}
                                                    </div>
                                                    <div className="detail-price2 col-4">
                                                        {data.price} {getCurrency(localStorage.getItem('countryShortName'))}
                                                    </div>
                                                    <textarea
                                                        type="text"
                                                        disabled={(data.qty || 0) === 0}
                                                        className="form-control cruise_search col-12 my-2"
                                                        style={{ height: '46px' }}
                                                        name="cruise_search"
                                                        id="cruise_search"
                                                        placeholder="Any Special request"
                                                        onChange={(event) => {
                                                            this.changeItemDetail('NOT', event.target.value, '')
                                                        }}
                                                        value={data.notes}
                                                    />
                                                    <div className="count-data col-6">
                                                        <span className="box" onClick={() => this.changeItemDetail('QTY', 0, data.stock_limit)}>
                                                            -
                                                        </span>
                                                        <div>{data.qty || 0}</div>
                                                        <span className="box" onClick={() => this.changeItemDetail('QTY', 1, data.stock_limit)}>
                                                            +
                                                        </span>
                                                    </div>
                                                    <div className="col-6">
                                                        <button
                                                            className="btn book-btn"
                                                            disabled={(data.qty || 0) === 0}
                                                            type="button"
                                                            onClick={() => this.addBulkQty()}
                                                        >
                                                            Add To Cart {data.price * data.qty || 0}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    addBulkQty = () => {
        let list = this.state.cartItemList
        let StoreObj = { ...this.state.storeMinAmtOrder }
        let prevPrice = 0
        let data = this.state.detailsOfitem

        if (list['id' + data.id]) {
            prevPrice = list['id' + data.id].price * list['id' + data.id].qty
        }

        list['id' + data.id] = data

        let total = this.state.totalAmt - prevPrice + data.price * data.qty

        if (data.storeId) {
            let totalAmtOfStoreItem = StoreObj['pId' + data.storeId] ? StoreObj['pId' + data.storeId]?.amt : 0
            StoreObj['pId' + data.storeId] = {
                amt: totalAmtOfStoreItem - prevPrice + data.price * data.qty,
                orderAmt: data.orderAmt,
                name: data.storeName,
            }
        }

        this.setState({
            cartItemList: list,
            totalAmt: total,
            detailsOfitem: '',
            storeMinAmtOrder: StoreObj,
        })
    }

    // ==================== CATERING SPECIFIC METHODS ====================

    openCateringItemDetail = (item) => {
        this.setState({
            showItemDetail: true,
            selectedItem: item,
            personCount: item.min_persons || 1,
            selectedCateringOptions: {},
            specialRequest: '',
        })
    }

    closeCateringItemDetail = () => {
        this.setState({
            showItemDetail: false,
            selectedItem: null,
            personCount: 0,
            selectedCateringOptions: {},
            specialRequest: '',
        })
    }

    handlePersonCount = (increment) => {
        const { selectedItem, personCount } = this.state
        const minPersons = selectedItem?.min_persons || 1
        const maxPersons = selectedItem?.max_persons || 100

        if (increment) {
            if (personCount < maxPersons) {
                this.setState({ personCount: personCount + 1 })
            } else {
                Swal.fire(`Maximum ${maxPersons} persons allowed`, '', 'warning')
            }
        } else {
            if (personCount > minPersons) {
                this.setState({ personCount: personCount - 1 })
            } else {
                Swal.fire(`Minimum ${minPersons} persons required`, '', 'warning')
            }
        }
    }

    handleCateringOptionChange = (categoryId, itemId, increment, maxItems, selectionType = 'multiple') => {
        const { selectedCateringOptions } = this.state
        const categoryOptions = selectedCateringOptions[categoryId] || {}
        const currentQty = categoryOptions[itemId] || 0
        const totalInCategory = Object.values(categoryOptions).reduce((sum, qty) => sum + qty, 0)

        if (increment) {
            if (totalInCategory < maxItems) {
                if (selectionType === 'single' && currentQty >= 1) {
                    Swal.fire('Only 1 quantity allowed for this item', '', 'warning')
                    return
                }
                this.setState({
                    selectedCateringOptions: {
                        ...selectedCateringOptions,
                        [categoryId]: { ...categoryOptions, [itemId]: currentQty + 1 },
                    },
                })
            } else {
                Swal.fire(`Maximum ${maxItems} items allowed in this category`, '', 'warning')
            }
        } else {
            if (currentQty > 0) {
                const newQty = currentQty - 1
                const newCategoryOptions = { ...categoryOptions }
                if (newQty === 0) delete newCategoryOptions[itemId]
                else newCategoryOptions[itemId] = newQty
                this.setState({
                    selectedCateringOptions: { ...selectedCateringOptions, [categoryId]: newCategoryOptions },
                })
            }
        }
    }

    getRemainingItems = (categoryId, maxItems) => {
        const { selectedCateringOptions } = this.state
        const categoryOptions = selectedCateringOptions[categoryId] || {}
        const totalSelected = Object.values(categoryOptions).reduce((sum, qty) => sum + qty, 0)
        return maxItems - totalSelected
    }

    calculateCateringTotal = () => {
        const { selectedItem, selectedCateringOptions, personCount } = this.state
        if (!selectedItem) return 0

        let total = selectedItem.item_amount || 0
        const minPersons = selectedItem.min_persons || 0
        const personPrice = selectedItem.person_price || 0
        if (personCount > minPersons && personPrice > 0) {
            total += (personCount - minPersons) * personPrice
        }

        if (selectedItem.catering_categories) {
            selectedItem.catering_categories.forEach((category) => {
                if (category.is_addon) {
                    const categoryOptions = selectedCateringOptions[category.id] || {}
                    category.items.forEach((item) => {
                        const qty = categoryOptions[item.id] || 0
                        total += item.price * qty
                    })
                }
            })
        }
        return total
    }

    validateRequiredCategories = () => {
        const { selectedItem, selectedCateringOptions } = this.state
        if (!selectedItem || !selectedItem.catering_categories) return { valid: true }

        for (const category of selectedItem.catering_categories) {
            if (category.is_addon) continue
            const maxItems = category.max_items || 0
            if (maxItems > 0) {
                const categoryOptions = selectedCateringOptions[category.id] || {}
                const totalSelected = Object.values(categoryOptions).reduce((sum, qty) => sum + qty, 0)
                if (totalSelected < maxItems) {
                    return { valid: false, categoryName: category.name, remaining: maxItems - totalSelected }
                }
            }
        }
        return { valid: true }
    }

    addCateringItemToCart = () => {
        const { selectedItem, personCount, selectedCateringOptions, specialRequest, cartItemList, totalAmt, storeMinAmtOrder } = this.state
        if (!selectedItem) return

        const validation = this.validateRequiredCategories()
        if (!validation.valid) {
            Swal.fire({ title: `Please select ${validation.remaining} more item(s) in "${validation.categoryName}"`, icon: 'warning', confirmButtonText: 'Ok' })
            return
        }

        const itemTotal = this.calculateCateringTotal()
        const itemId = selectedItem.id

        const cartItem = {
            id: itemId,
            store_id: selectedItem.store_id,
            title: selectedItem.name,
            img: selectedItem.image,
            price: itemTotal,
            qty: 1,
            personCount: personCount,
            selectedCateringOptions: { ...selectedCateringOptions },
            cateringCategories: selectedItem.catering_categories || [],
            notes: specialRequest,
            isCateringItem: true,
            storeId: this.state.foodOrStoreSelectOnceData?.id,
            orderAmt: this.state.foodOrStoreSelectOnceData?.minimumOrderAmount || 0,
            storeName: this.state.foodOrStoreSelectOnceData?.name,
        }

        const newCartList = { ...cartItemList }
        newCartList['id' + itemId] = cartItem

        const StoreObj = { ...storeMinAmtOrder }
        const storeId = this.state.foodOrStoreSelectOnceData?.id
        if (storeId) {
            const prevAmt = StoreObj['pId' + storeId]?.amt || 0
            StoreObj['pId' + storeId] = {
                amt: prevAmt + itemTotal,
                orderAmt: this.state.foodOrStoreSelectOnceData?.minimumOrderAmount || 0,
                name: this.state.foodOrStoreSelectOnceData?.name,
            }
        }

        this.setState({ cartItemList: newCartList, totalAmt: totalAmt + itemTotal, storeMinAmtOrder: StoreObj })
        this.closeCateringItemDetail()
        Swal.fire('Added to cart!', '', 'success')
    }

    renderCateringItemCard = (item) => {
        const currency = getCurrency(localStorage.getItem('countryShortName'))
        return (
            <div key={item.id} onClick={() => this.openCateringItemDetail(item)} style={{ display: 'flex', alignItems: 'center', padding: '15px', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
                <img src={item.image ? Constant.getImage() + item.image : './assets/images/waves-logo.svg'} alt={item.name} style={{ width: '60px', height: '60px', borderRadius: '8px', objectFit: 'cover', marginRight: '15px' }} onError={(e) => { e.target.src = './assets/images/waves-logo.svg' }} />
                <div>
                    <h5 style={{ margin: '0 0 5px 0', fontSize: '14px', fontWeight: '500' }}>{item.name}</h5>
                    <p style={{ margin: 0, color: '#00547e', fontSize: '13px', fontWeight: '500' }}>{item.item_amount} {currency}</p>
                </div>
            </div>
        )
    }

    renderCateringCartItem = (cartItem) => {
        const currency = getCurrency(localStorage.getItem('countryShortName'))
        const selectedOptions = cartItem.selectedCateringOptions || {}
        const categories = cartItem.cateringCategories || []
        const selectedItemsList = []

        categories.forEach((category) => {
            const categoryOptions = selectedOptions[category.id] || {}
            category.items.forEach((item) => {
                const qty = categoryOptions[item.id] || 0
                if (qty > 0) selectedItemsList.push({ name: item.name, qty })
            })
        })

        return (
            <div
                key={cartItem.id}
                style={{
                    padding: '15px',
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <img
                        src={cartItem.img ? Constant.getImage() + cartItem.img : './assets/images/waves-logo.svg'}
                        alt={cartItem.title}
                        style={{
                            width: '55px',
                            height: '55px',
                            borderRadius: '8px',
                            objectFit: 'cover',
                            marginRight: '12px',
                            flexShrink: 0
                        }}
                        onError={(e) => { e.target.src = './assets/images/waves-logo.svg' }}
                    />
                    <div style={{ flex: 1 }}>
                        <h5 style={{ margin: '0 0 4px 0', fontSize: '14px', fontWeight: '600', color: '#333' }}>{cartItem.title}</h5>
                        <span style={{
                            fontSize: '10px',
                            color: '#fff',
                            backgroundColor: '#ff9800',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            display: 'inline-block',
                            marginBottom: '6px'
                        }}>
                            Catering
                        </span>
                        {cartItem.personCount && (
                            <p style={{ margin: '0 0 4px 0', fontSize: '12px', color: '#666' }}>
                                {cartItem.personCount} persons
                            </p>
                        )}
                    </div>
                    <p style={{
                        margin: 0,
                        color: '#00547e',
                        fontSize: '16px',
                        fontWeight: '700',
                        whiteSpace: 'nowrap'
                    }}>
                        {cartItem.price} {currency}
                    </p>
                </div>
                {selectedItemsList.length > 0 && (
                    <div style={{
                        marginTop: '10px',
                        paddingTop: '10px',
                        borderTop: '1px dashed #eee',
                        fontSize: '12px',
                        color: '#666',
                        lineHeight: '1.8'
                    }}>
                        {selectedItemsList.map((item, index) => (
                            <div key={index} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span>• {item.name}</span>
                                <span style={{ color: '#999' }}>x {item.qty}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        )
    }

    // Render regular cart item with improved design
    renderCartItem = (item) => {
        const currency = getCurrency(localStorage.getItem('countryShortName'))
        const isDiwaniya = item.diwaniya

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '12px 15px',
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                }}
            >
                {/* Item Image */}
                <div style={{ flexShrink: 0, marginRight: '12px' }}>
                    <img
                        src={item.img ? Constant.getImage() + item.img : './assets/images/waves-logo.svg'}
                        alt={item.title}
                        style={{
                            width: '55px',
                            height: '55px',
                            borderRadius: '8px',
                            objectFit: 'cover',
                        }}
                        onError={(e) => { e.target.src = './assets/images/waves-logo.svg' }}
                    />
                </div>

                {/* Item Details */}
                <div style={{ flex: 1, minWidth: 0 }}>
                    <h5 style={{
                        margin: '0 0 4px 0',
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#333',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}>
                        {item.title}
                    </h5>
                    {isDiwaniya && (
                        <span style={{
                            fontSize: '10px',
                            color: '#fff',
                            backgroundColor: '#00b4b4',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            display: 'inline-block',
                            marginBottom: '4px'
                        }}>
                            Add-on
                        </span>
                    )}
                    <p style={{
                        margin: 0,
                        color: '#00547e',
                        fontSize: '14px',
                        fontWeight: '600'
                    }}>
                        {item.price} {currency}
                    </p>
                </div>

                {/* Quantity Controls */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginLeft: '10px',
                }}>
                    <span
                        onClick={() => this.addOrRemoveFromCart(item, 0)}
                        style={{
                            width: '28px',
                            height: '28px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            color: '#00547e',
                            fontWeight: '600',
                        }}
                    >
                        -
                    </span>
                    <span style={{
                        minWidth: '24px',
                        textAlign: 'center',
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#333',
                    }}>
                        {item.qty}
                    </span>
                    <span
                        onClick={() => this.addOrRemoveFromCart(item, 1)}
                        style={{
                            width: '28px',
                            height: '28px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#00547e',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            color: '#fff',
                            fontWeight: '600',
                        }}
                    >
                        +
                    </span>
                </div>
            </div>
        )
    }

    render() {
        const { tabList, activeTab, circleTab, activeAddOnTab, foodOrStoreSelectOnceData, showCart, showCheckout, cartItemList, isLoadingStores, isLoadingItems, isProcessingCheckout, activeAddOnSubTab } = this.state
        const currency = getCurrency(localStorage.getItem('countryShortName'))

        return (
            <>
                <div className="scroll" style={{ position: 'relative' }}>
                    {/* Loader Overlay for Processing States */}
                    {(isProcessingCheckout || this.state.isProcessingPayment || this.state.initialLoading) && (
                        <div className="loader-overlay">
                            <div className="loader"></div>
                        </div>
                    )}
                    {showCheckout ? (
                        /* Checkout View */
                        <div>
                            <div className="top-button">
                                <div className="button-data">
                                    <span>
                                        <img
                                            src="./assets/icon/concierge/arrow-prev-back.svg"
                                            alt="Back"
                                            style={{ width: '25px', cursor: 'pointer' }}
                                            onClick={this.handleCart}
                                        />
                                    </span>
                                    <h1 className="m-0 heading">Checkout</h1>
                                    <div> </div>
                                </div>
                            </div>

                            <div className="checkout-padding">
                                {(() => {
                                    const { bookingData } = this.state;
                                    const checkInTime = moment(bookingData?.check_in_time, 'HH:mm:ss').format('hh:mm A');
                                    const checkOutTime = moment(bookingData?.check_out_time, 'HH:mm:ss').format('hh:mm A');
                                    const checkInDate = moment(bookingData?.check_in_date, 'YYYY-MM-DD').format('dddd, D MMMM');
                                    const checkOutDate = moment(bookingData?.check_out_date, 'YYYY-MM-DD').format('dddd, D MMMM');

                                    return (
                                        <div className="checkout">
                                            <div className="checkout-w-33">
                                                <h5>Check In</h5>
                                                <p>{checkInDate}</p>
                                                <span>{checkInTime}</span>
                                            </div>
                                            <div className="checkout-w-33 text-center checkout-yatch-data">
                                                {bookingData?.chalet_image && (
                                                    <img
                                                        src={Constant.getImage() + bookingData?.chalet_image}
                                                        alt={bookingData?.chalet_name || this.state.title}
                                                        style={{
                                                            width: '80px',
                                                            height: '80px',
                                                            objectFit: 'cover',
                                                            borderRadius: '8px',
                                                        }}
                                                    />
                                                )}
                                                <h3>{bookingData?.chalet_name || this.state.title}</h3>
                                            </div>
                                            <div className="checkout-w-33 text-right">
                                                <h5>Check Out</h5>
                                                <p>{checkOutDate}</p>
                                                <span>{checkOutTime}</span>
                                            </div>
                                        </div>
                                    );
                                })()}

                                <div className="payment-data">
                                    <h3>Payment Summary</h3>

                                    <div className="payment-details">
                                        <p>Chalet Total</p>
                                        <h1>
                                            {this.state.bookingData?.paymentSummary?.chalet_amount || 0}{' '}
                                            {currency}
                                        </h1>
                                    </div>
                                    <div className="payment-details">
                                        <p>Diwaniya Items Total</p>
                                        <h1>
                                            {this.state.bookingData?.paymentSummary?.diwaniya_items_total || 0}{' '}
                                            {currency}
                                        </h1>
                                    </div>
                                    <div className="payment-details">
                                        <p>Store Items Total</p>
                                        <h1>
                                            {this.state.bookingData?.paymentSummary?.store_items_total || 0}{' '}
                                            {currency}
                                        </h1>
                                    </div>
                                    <div className="payment-details">
                                        <p>Food Items Total</p>
                                        <h1>
                                            {this.state.bookingData?.paymentSummary?.food_items_total || 0}{' '}
                                            {currency}
                                        </h1>
                                    </div>
                                    <div className="payment-details">
                                        <p>Catering Total</p>
                                        <h1>
                                            {this.state.bookingData?.paymentSummary?.catering_total || 0}{' '}
                                            {currency}
                                        </h1>
                                    </div>
                                    <div className="payment-details">
                                        <p>Delivery Charge</p>
                                        <h1>
                                            {this.state.bookingData?.paymentSummary?.deliveryCharge || 0}{' '}
                                            {currency}
                                        </h1>
                                    </div>
                                    <div className="payment-details">
                                        <p>Cost Of Service</p>
                                        <h1>
                                            {this.state.bookingData?.paymentSummary?.cost_of_service || 0}{' '}
                                            {currency}
                                        </h1>
                                    </div>
                                    <div className="payment-details">
                                        <p>Coupon Applied Amount</p>
                                        <h1>
                                            {this.state.bookingData?.paymentSummary?.coupon_applied_amount || 0}{' '}
                                            {currency}
                                        </h1>
                                    </div>
                                    <div className="payment-details">
                                        <p>Vat ({this.state.bookingData?.paymentSummary?.vat || 0}%)</p>
                                        <h1>
                                            {this.state.bookingData?.paymentSummary?.vat_amount || 0}{' '}
                                            {currency}
                                        </h1>
                                    </div>
                                    <div className="payment-details payment-details-total">
                                        <p>Total</p>
                                        <h1>
                                            {this.state.bookingData?.paymentSummary?.total_booking_amount || 0}{' '}
                                            {currency}
                                        </h1>
                                    </div>
                                    <div className="text-center buttondata">
                                        <button
                                            className="btn book-btn"
                                            type="button"
                                            onClick={this.processPayment}
                                            disabled={this.state.isProcessingPayment}
                                        >
                                            {this.state.isProcessingPayment ? (
                                                'Processing...'
                                            ) : (
                                                <>Process Payment {this.state.bookingData?.paymentSummary?.total_booking_amount || 0} {currency}</>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            {/* Header with Title and Cart */}
                            <div className="top-button" style={{ flexShrink: 0 }}>
                                <div className="button-data">
                                    <span>
                                        {showCart ? (
                                            <img
                                                src="./assets/icon/concierge/arrow-prev-back.svg"
                                                alt="Back"
                                                style={{ width: '25px', cursor: 'pointer' }}
                                                onClick={this.handleCart}
                                            />
                                        ) : ''}
                                    </span>
                                    <h1 className="m-0 heading">{showCart ? 'Cart' : `${this.state.title} - Add-ons`}</h1>
                                    <div
                                        style={{ height: '22px', position: 'relative', cursor: 'pointer' }}
                                        onClick={() => this.setState({ showCart: !showCart, showCheckout: 0 })}
                                    >
                                        <img src="./assets/icon/concierge/cart.svg" alt="Cart" style={{ width: '30px' }} />
                                        {Object.keys(cartItemList).length > 0 && (
                                            <span
                                                className="m-0 heading"
                                                style={{
                                                    position: 'absolute',
                                                    right: '-4px',
                                                    top: '-3px',
                                                    height: '19px',
                                                    width: '18px',
                                                    backgroundColor: '#adadff',
                                                    fontSize: '10px',
                                                    textAlign: 'center',
                                                    borderRadius: '15px',
                                                    lineHeight: '18px',
                                                }}
                                            >
                                                {Object.keys(cartItemList).length}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Content Area */}
                            {showCart ? (
                                /* Cart View - Improved Design */
                                <div className="add-on-data" style={{ flex: 1, overflow: 'auto', padding: '15px' }}>
                                    {Object.keys(cartItemList).length ? (
                                        <>
                                            {/* Cart Items */}
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
                                                {Object.values(cartItemList).map((ele, i) => {
                                                    if (ele.isCateringItem) {
                                                        return <div key={i}>{this.renderCateringCartItem(ele)}</div>
                                                    }
                                                    return <div key={i}>{this.renderCartItem(ele)}</div>
                                                })}
                                            </div>

                                            {/* Delivery Date & Time Section */}
                                            <div style={{
                                                backgroundColor: '#fff',
                                                borderRadius: '10px',
                                                padding: '15px',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                marginBottom: '15px'
                                            }}>
                                                <h5 style={{ margin: '0 0 10px 0', fontSize: '14px', fontWeight: '600', color: '#333' }}>
                                                    Delivery Date & Time
                                                </h5>
                                                <div
                                                    onClick={this.openDeliveryModal}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        padding: '12px 15px',
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '8px',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#fafafa'
                                                    }}
                                                >
                                                    <span style={{
                                                        fontSize: '13px',
                                                        color: this.getFormattedDeliveryDateTime() ? '#00547e' : '#999',
                                                        fontWeight: this.getFormattedDeliveryDateTime() ? '500' : '400'
                                                    }}>
                                                        {this.getFormattedDeliveryDateTime() || 'Select Delivery Date & Time'}
                                                    </span>
                                                    <img
                                                        src="./assets/icon/concierge/calendar.svg"
                                                        alt="Calendar"
                                                        style={{ width: '20px', opacity: 0.7 }}
                                                        onError={(e) => { e.target.style.display = 'none' }}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 20px', color: '#999' }}>
                                            <img src="./assets/icon/concierge/cart.svg" alt="Empty Cart" style={{ width: '60px', opacity: 0.5, marginBottom: '15px' }} />
                                            <h5 style={{ margin: 0, color: '#666' }}>Your cart is empty</h5>
                                            <p style={{ margin: '8px 0 0 0', fontSize: '13px' }}>Add items to get started</p>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                /* Main Content with Tabs */
                                <div className="add-on-data" style={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ padding: '0 10px', flexShrink: 0 }}>
                                        {/* Tab Navigation with Images */}
                                        <div className="add-tab">
                                            {tabList.map((tab, i) => (
                                                <div
                                                    key={i}
                                                    className={`box ${activeTab === tab.id ? 'select' : ''}`}
                                                    onClick={() => { this.setState({ showCheckout: 0 }); this.setActiveTab(tab.id) }}
                                                >
                                                    {this.imageManger(tab.imageSelected)}
                                                    <p className="m-0">{tab.name_en || tab.name}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Tab Content */}
                                    <div className="tab-content" style={{ flex: 1, overflow: 'auto' }}>
                                        {/* Category/Store Selection */}
                                        <div className="add-cat" style={{ flexShrink: 0 }}>
                                            {isLoadingStores ? this.renderInlineLoader(80) : (
                                                circleTab?.map((ele, i) => (
                                                    <div key={i} className={`add-cat-data ${activeAddOnTab?.id === ele.id ? 'select' : ''}`} onClick={() => this.setActiveAddOnTab(ele)}>
                                                        {this.imageManger(activeTab === 'FUN' ? ele.img : ele.shop_img)}
                                                        <p className="mb-1">{activeTab === 'FUN' ? ele.name : ele.shop_name}</p>
                                                    </div>
                                                ))
                                            )}
                                        </div>

                                        {/* FUN Tab - Diwaniya Items */}
                                        {activeTab === 'FUN' && (
                                            <div style={{ overflow: 'auto', padding: '0 10px' }}>
                                                {activeAddOnTab?.diwaniya && activeAddOnTab?.diwaniya.length > 0 && (
                                                    <div className="data-add-box">
                                                        {activeAddOnTab?.diwaniya?.map((ele, i) => (
                                                            <div key={i}>
                                                                {this.productCard(ele.item_img_thumb, ele.item_name, ele.item_amount, { diwaniya: 1, ...ele })}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* FOOD, STORE, CATERING Tabs */}
                                        {activeTab !== 'FUN' && (
                                            <div>
                                                {isLoadingItems ? this.renderInlineLoader(100) : (
                                                    foodOrStoreSelectOnceData && Object.keys(foodOrStoreSelectOnceData).length > 0 && (
                                                        <>
                                                            <div className="box-details">
                                                                <h4>{foodOrStoreSelectOnceData?.name}</h4>
                                                                <ul>
                                                                    {Array.apply(null, Array(5))?.map((ele, i) => (
                                                                        <li key={i}>
                                                                            {i > foodOrStoreSelectOnceData?.ratings - 1 ? (
                                                                                <img src="./assets/icon/concierge/unfill-star.svg" alt="" />
                                                                            ) : (
                                                                                <img src="./assets/icon/concierge/star.svg" alt="" />
                                                                            )}
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                                <span onClick={() => this.setState({ descriptionExpand: this.state.descriptionExpand ? 0 : 1 })}>
                                                                    {this.state.descriptionExpand ? (
                                                                        <p>{foodOrStoreSelectOnceData?.description?.length > 100 ? foodOrStoreSelectOnceData?.description.substring(0, 100) + '...' : foodOrStoreSelectOnceData?.description}</p>
                                                                    ) : (
                                                                        <p>{foodOrStoreSelectOnceData?.description}</p>
                                                                    )}
                                                                </span>
                                                                <div className="fee-del">
                                                                    <span>Delivery Fee:</span>
                                                                    <p>{foodOrStoreSelectOnceData?.deliverCharge} {currency}</p>
                                                                </div>
                                                            </div>
                                                            {foodOrStoreSelectOnceData.categories && (
                                                                <div className="child-data">
                                                                    <div className="child-box">
                                                                        {foodOrStoreSelectOnceData?.categories.map((ele, index) => (
                                                                            <div key={index} className={`box ${activeAddOnSubTab === index ? 'select' : ''}`} onClick={() => this.setActiveAddOnSubTab(index)}>
                                                                                <p>{ele.name}</p>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            {foodOrStoreSelectOnceData?.categories[activeAddOnSubTab] ? (
                                                                                activeTab === 'CATERING' ? (
                                                                                    /* CATERING tab - always vertical layout for all items */
                                                                                    <div style={{ backgroundColor: '#fff' }}>
                                                                                        {foodOrStoreSelectOnceData?.categories[activeAddOnSubTab]?.storeItems?.map((ele, index) => (
                                                                                            <div key={index}>{this.renderCateringItemCard(ele)}</div>
                                                                                        ))}
                                                                                    </div>
                                                                                ) : (
                                                                                    /* FOOD and STORE tabs - regular grid layout like AddOns.js */
                                                                                    <div className="data-add-box">
                                                                                        {foodOrStoreSelectOnceData?.categories[activeAddOnSubTab]?.storeItems?.map((ele, index) => (
                                                                                            <div key={index}>
                                                                                                {this.productCard(ele.image, ele.name, ele.item_amount, {
                                                                                                    ...ele,
                                                                                                    storeId: foodOrStoreSelectOnceData?.id,
                                                                                                    orderAmt: foodOrStoreSelectOnceData?.minimumOrderAmount,
                                                                                                    storeName: foodOrStoreSelectOnceData?.name,
                                                                                                })}
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                )
                                                                            ) : (
                                                                                <div className="mt-3 no-data"><h5>No Item</h5></div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    )
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Item Detail Modal */}
                            {this.state.detailsOfitem && this.state.detailsOfitem.id && this.setDetailsOfitem()}

                            {/* Catering Item Detail Modal */}
                            {this.state.showItemDetail && this.renderCateringItemDetail()}
                        </div>
                    )}
                </div>
                {!showCheckout && !this.state.showItemDetail && (
                    <div>
                        {this.storeMinOrderAmtAlert()}
                        <div style={{ padding: '10px 20px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderTop: '1px solid #ccc' }}>
                            <button
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}
                                type="button"
                                className="btn book-btn"
                                onClick={() => this.bottmBtn()}
                                disabled={isProcessingCheckout}
                            >
                                {isProcessingCheckout ? (
                                    <>
                                        <div style={{ width: 18, height: 18, border: '2px solid #fff', borderTop: '2px solid transparent', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
                                        <div>Processing...</div>
                                    </>
                                ) : showCart ? (
                                    <div>
                                        {this.state.selectedDeliveryDate && this.state.selectedDeliveryTime ? 'Proceed To Checkout' : 'Checkout'}
                                        {this.state.totalAmt ? (
                                            <span>{' ' + this.state.totalAmt + ' ' + currency}</span>
                                        ) : ''}
                                    </div>
                                ) : (
                                    <div>Next</div>
                                )}
                            </button>
                        </div>
                    </div>
                )}

                {/* Delivery Date/Time Modal */}
                {this.renderDeliveryModal()}
            </>
        )
    }

    // Render catering item detail view - shows inline in the same popup
    renderCateringItemDetail = () => {
        const { selectedItem, personCount, selectedCateringOptions, specialRequest } = this.state
        if (!selectedItem) return null

        const currency = getCurrency(localStorage.getItem('countryShortName'))
        const itemTotal = this.calculateCateringTotal()
        const mainImage = selectedItem.image
        const minPersons = selectedItem.min_persons || 0
        const maxPersons = selectedItem.max_persons || 100
        const personPrice = selectedItem.person_price || 0

        return (
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: '#fff',
                zIndex: 100,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}>
                {/* Header with Back button and Image */}
                <div style={{
                    position: 'relative',
                    minHeight: '200px',
                    maxHeight: '250px',
                    backgroundColor: '#f5f5f5',
                    flexShrink: 0,
                }}>
                    <div
                        onClick={this.closeCateringItemDetail}
                        style={{
                            position: 'absolute',
                            top: '15px',
                            left: '15px',
                            color: '#00547e',
                            cursor: 'pointer',
                            zIndex: 10,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            fontSize: '14px',
                            fontWeight: '600',
                            backgroundColor: 'rgba(255,255,255,0.9)',
                            padding: '5px 10px',
                            borderRadius: '5px',
                        }}
                    >
                        <span style={{ fontSize: '18px' }}>{'<'}</span> Back
                    </div>
                    <img
                        src={mainImage ? Constant.getImage() + mainImage : './assets/images/waves-logo.svg'}
                        alt={selectedItem.name}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        }}
                        onError={(e) => { e.target.src = './assets/images/waves-logo.svg' }}
                    />
                </div>

                {/* Scrollable Content */}
                <div style={{
                    flex: 1,
                    overflowY: 'auto',
                    padding: '20px',
                }}>
                    {/* Item Name and Price with Person Counter */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: '15px',
                    }}>
                        <div>
                            <h3 style={{ color: '#00547e', margin: '0 0 5px 0', fontSize: '18px' }}>
                                {selectedItem.name}
                            </h3>
                            <p style={{ color: '#00547e', margin: 0, fontWeight: '600' }}>
                                {selectedItem.item_amount} {currency}
                            </p>
                            {personPrice > 0 && (
                                <p style={{ color: '#888', margin: '5px 0 0 0', fontSize: '12px' }}>
                                    (Extra person: {personPrice} {currency}/person)
                                </p>
                            )}
                        </div>
                        {/* Person Counter */}
                        <div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                border: '1px solid #ddd',
                                borderRadius: '5px',
                                padding: '5px 10px',
                            }}>
                                <span
                                    onClick={() => this.handlePersonCount(false)}
                                    style={{
                                        cursor: personCount <= minPersons ? 'not-allowed' : 'pointer',
                                        padding: '0 8px',
                                        fontSize: '18px',
                                        color: personCount <= minPersons ? '#ccc' : '#00547e',
                                    }}
                                >
                                    -
                                </span>
                                <span style={{ minWidth: '30px', textAlign: 'center' }}>{personCount}</span>
                                <span
                                    onClick={() => this.handlePersonCount(true)}
                                    style={{
                                        cursor: personCount >= maxPersons ? 'not-allowed' : 'pointer',
                                        padding: '0 8px',
                                        fontSize: '18px',
                                        color: personCount >= maxPersons ? '#ccc' : '#00547e',
                                    }}
                                >
                                    +
                                </span>
                            </div>
                            <p style={{ color: '#888', margin: '5px 0 0 0', fontSize: '11px', textAlign: 'center' }}>
                                {minPersons}-{maxPersons} persons
                            </p>
                        </div>
                    </div>

                    {/* Description */}
                    <div
                        style={{
                            fontSize: '13px',
                            color: '#666',
                            marginBottom: '20px',
                            lineHeight: '1.5',
                        }}
                        dangerouslySetInnerHTML={{ __html: selectedItem.description }}
                    />

                    {/* Catering Categories */}
                    {selectedItem.catering_categories && selectedItem.catering_categories.map((category) => {
                        const remaining = this.getRemainingItems(category.id, category.max_items)
                        const categoryOptions = selectedCateringOptions[category.id] || {}
                        const isCompulsory = !category.is_addon

                        return (
                            <div key={category.id} style={{ marginBottom: '25px' }}>
                                {/* Category Header */}
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '15px',
                                    borderBottom: '1px solid #eee',
                                    paddingBottom: '10px',
                                }}>
                                    <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                                        {category.name}
                                    </h4>
                                    {isCompulsory && remaining > 0 && (
                                        <span style={{
                                            color: '#dc3545',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                        }}>
                                            Choose {remaining} more
                                        </span>
                                    )}
                                </div>

                                {/* Category Items */}
                                {category.items.map((item) => {
                                    const itemQty = categoryOptions[item.id] || 0
                                    const isSingleSelection = item.selection === 'single'

                                    return (
                                        <div
                                            key={item.id}
                                            style={{
                                                border: '1px solid #eee',
                                                borderRadius: '8px',
                                                padding: '15px',
                                                marginBottom: '10px',
                                            }}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                            }}>
                                                <div style={{ flex: 1, paddingRight: '15px' }}>
                                                    <h5 style={{
                                                        color: '#00547e',
                                                        margin: '0 0 8px 0',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                    }}>
                                                        {item.name}
                                                    </h5>
                                                    {item.desc && (
                                                        <p style={{
                                                            color: '#888',
                                                            fontSize: '12px',
                                                            margin: '0 0 8px 0',
                                                            lineHeight: '1.4',
                                                        }}>
                                                            {item.desc}
                                                        </p>
                                                    )}
                                                    {category.is_addon && (
                                                        <p style={{
                                                            color: '#00547e',
                                                            fontSize: '13px',
                                                            margin: 0,
                                                            fontWeight: '500',
                                                        }}>
                                                            {item.price} {currency}
                                                        </p>
                                                    )}
                                                </div>
                                                {/* Quantity Counter */}
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '5px',
                                                    padding: '3px 8px',
                                                }}>
                                                    <span
                                                        onClick={() => this.handleCateringOptionChange(category.id, item.id, false, category.max_items, item.selection)}
                                                        style={{
                                                            cursor: itemQty === 0 ? 'not-allowed' : 'pointer',
                                                            padding: '0 5px',
                                                            fontSize: '16px',
                                                            color: itemQty === 0 ? '#ccc' : '#00547e',
                                                        }}
                                                    >
                                                        -
                                                    </span>
                                                    <span style={{ minWidth: '20px', textAlign: 'center', color: '#00547e' }}>{itemQty}</span>
                                                    <span
                                                        onClick={() => this.handleCateringOptionChange(category.id, item.id, true, category.max_items, item.selection)}
                                                        style={{
                                                            cursor: (remaining === 0 || (isSingleSelection && itemQty >= 1)) ? 'not-allowed' : 'pointer',
                                                            padding: '0 5px',
                                                            fontSize: '16px',
                                                            color: (remaining === 0 || (isSingleSelection && itemQty >= 1)) ? '#ccc' : '#00547e',
                                                        }}
                                                    >
                                                        +
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    })}

                    {/* Special Request */}
                    <div style={{ marginBottom: '20px' }}>
                        <h4 style={{ margin: '0 0 10px 0', fontSize: '16px', fontWeight: '600' }}>Any special request?</h4>
                        <textarea
                            placeholder="your request"
                            value={specialRequest}
                            onChange={(e) => this.setState({ specialRequest: e.target.value })}
                            style={{
                                width: '100%',
                                minHeight: '80px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '12px',
                                fontSize: '14px',
                                resize: 'vertical',
                                boxSizing: 'border-box',
                            }}
                        />
                    </div>
                </div>

                {/* Add to Basket Button */}
                <div style={{
                    padding: '15px 20px',
                    borderTop: '1px solid #eee',
                    backgroundColor: '#fff',
                    flexShrink: 0,
                }}>
                    <button
                        onClick={this.addCateringItemToCart}
                        style={{
                            width: '100%',
                            backgroundColor: '#00547e',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '15px',
                            fontSize: '16px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <span>Add To Basket</span>
                        <span>{itemTotal} {currency}</span>
                    </button>
                </div>
            </div>
        )
    }
}

export default ChaletAddOns
